import * as loglevel from 'loglevel';
import config from '@src/config';

if (config?.loglevel) {
    loglevel.setLevel(config.loglevel);
}

export default loglevel;
